<form 
  [formGroup]="paymentForm" 
  (ngSubmit)="submitPayment()" 
  class="space-y-6 bg-white p-6 rounded-2xl shadow-lg w-full max-w-md mx-auto"
>

  <!-- Card Number -->
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">Card Number</label>
    <input 
      formControlName="cardNumber" 
      type="text" 
      maxlength="16" 
      placeholder="4111 1111 1111 1111"
      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    />
  </div>

  <!-- Expiration -->
  <div class="grid grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Exp Month</label>
      <input 
        formControlName="expMonth" 
        type="text" 
        placeholder="MM"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Exp Year</label>
      <input 
        formControlName="expYear" 
        type="text" 
        placeholder="YYYY"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
      />
    </div>
  </div>

  <!-- CVV -->
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">CVV</label>
    <input 
      formControlName="cvv" 
      type="text" 
      maxlength="4" 
      placeholder="123"
      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    />
  </div>

  <!-- Email -->
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">Email (optional)</label>
    <input 
      formControlName="email" 
      type="email" 
      placeholder="customer@example.com"
      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    />
  </div>

  <!-- Submit -->
  <button mat-flat-button color="primary" type="submit" [disabled]="paymentProcessing" class="w-full"> {{ paymentProcessing ? 'Processing...' : 'Confirm Payment' }} </button>
</form>
